import React from 'react'
import PropTypes from 'prop-types'
import { Provider, observer } from 'mobx-react'
import EmployeeModal from './EmployeeModal'
import BookNowButton from '../../ui/BookNowButton'

@observer
export default class EmployeeThumbnail extends React.Component {
  static propTypes = {
    employee: PropTypes.object.isRequired,
    showBookNowButton: PropTypes.bool.isRequired,
    bookNowButtonText: PropTypes.string.isRequired,
    style: PropTypes.any
  }

  state = {
    showModal: false
  }

  handleShow = () => {
    this.setState({ showModal: true })
  }

  handleClose = () => {
    this.setState({ showModal: false })
  }

  render() {
    const { employee, style, showBookNowButton, bookNowButtonText } = this.props
    const { showModal } = this.state

    return (
      <div style={{...styles.container, ...style}}>
        <EmployeeModal
          employee={employee}
          showBookNowButton={showBookNowButton}
          bookNowButtonText={bookNowButtonText}
          show={showModal}
          onClose={this.handleClose}
        />
        <div onClick={this.handleShow}>
          <div style={styles.title}>
            { employee.attributes.name }
          </div>
          <div style={styles.imageWrapper}>
            <img
              src={employee.attributes.primaryImage.largeVariant}
              style={styles.image}
              loading="lazy"
            />
          </div>
        </div>
        <div style={styles.bookNowContainer}>
          <BookNowButton
            showBookNowButton={showBookNowButton}
            bookNowButtonText={bookNowButtonText}
          />
        </div>
      </div>
    )
  }
}

const styles = {
  container: {
    cursor: 'pointer',
    marginBottom: 30
  },
  title: {
    fontSize: 18,
    fontWeight: "bold",
    color: "#000",
    textAlign: "center"
  },
  imageWrapper: {
    height: 200,
    textAlign: "center"
  },
  image: {
    maxWidth: "100%",
    maxHeight: "100%",
    width: "auto",
    height: "auto"
  },
  bookNowContainer: {
    marginTop: 10,
    textAlign: "center"
  }
}
